var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dialog-email',{ref:"dialog-email",attrs:{"contentKey":_vm.contentKey,"contentMap":_vm.contentMap,"data":_vm.emailData,"isLoading":_vm.isLoading},on:{"on-submit-email":_vm.handlerSubmit,"close":_vm.handleClose}})}
var staticRenderFns = []

export { render, staticRenderFns }